
import { i18nManager } from "../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import Notifications from "../../shared/Notifications";
import { NotificationGroup } from "../../shared/Notifiier";
import { ApiResponseData, BaseService, INotification, MemberNotificationService, SanitizedResponse } from "../../../services";
import { Siren } from "../../shared/ConfirmDialog";

function ProfileNotifications() {

    const memberNotificationService = MemberNotificationService.getInstance();
    const [searchParams, _] = ReactRouterDom.useSearchParams(window.location.search);

    return (<Notifications
        service={memberNotificationService}
        title={i18nManager.Labels.compound.top_navbar.popover.notification.notifications}
        markAllAsRead={(done, success) => {
            memberNotificationService.markAllAsRead().then(({ }: SanitizedResponse<void>) => {
                Siren.alert(i18nManager.Labels.compound.top_navbar.popover.notification.mark_all_read_success);
                success();
            }).catch(BaseService.reportError).finally(done);
        }}
        fetch={(section, done, success) => {
            memberNotificationService.queryNotifications({
                page: parseInt(searchParams.get("page") ?? "1"),
                size: parseInt(searchParams.get("size") ?? "50"),
                status: (section === "unread" ? "UN_READ" : undefined),
            }).then(({ sanitized, apiResponse }: SanitizedResponse<ApiResponseData<INotification> & { grouped_notifications: NotificationGroup }>) => {
                success(sanitized, apiResponse.secondary_data.un_reads.notifications);
            }).catch(BaseService.reportError).finally(done);
        }}
    />)

}

export default ProfileNotifications;
